const AVATAR_PALETTE = [
  { background: "#1e5bff", color: "#ffffff" },
  { background: "#0d9488", color: "#ffffff" },
  { background: "#7c3aed", color: "#ffffff" },
  { background: "#db2777", color: "#ffffff" },
  { background: "#ea580c", color: "#ffffff" },
  { background: "#0891b2", color: "#ffffff" },
  { background: "#4f46e5", color: "#ffffff" },
  { background: "#059669", color: "#ffffff" },
];

export function getProfileInitials(name, fallback = "?") {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return fallback;
  return parts
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
}

export function getAvatarColorFromName(name) {
  const text = String(name || "").trim();
  if (!text) return AVATAR_PALETTE[0];
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
}
